import {Box, styled} from "@mui/material"
import React from "react"
import Content from "../../components/Content"

export const containerGridPrototype = [
    "gridconfiguration",
    {
        key: "maxWidth",
        type: "INTEGER",
        label: "max width",
        size: 3,
    },
]

const GRID = styled(Box)(({theme}) => theme.GRID)

const ContainerGrid = ({container, disabled}) => {
    const {children, columncount, fullHeight} = container
    return (
        <Box
            display="flex"
            width="100%"
            justifyContent="center">
            <GRID
                display="grid"
                gridTemplateColumns={`repeat(${columncount},1fr)`}
                height={fullHeight ? "100%" : "auto"}
                rowGap={container.rowGap}
                columnGap={container.columnGap}
                maxWidth={
                    container.maxWidth > 0
                        ? `${container.maxWidth}px`
                        : "inherit"
                }
                width="100%">
                {children?.map((child) => (
                    <Box
                        key={child.id}
                        sx={{
                            gridColumn: child.x + 1 + " /span " + child.w,
                            gridRow: child.y + 1 + " /span " + child.h,
                        }}
                        height={child.fullHeight ? "100%" : "auto"}>
                        <Content
                            key={child.id}
                            child={child}
                            disabled={disabled}
                        />
                    </Box>
                ))}
            </GRID>
        </Box>
    )
}

export default ContainerGrid
